import { render, staticRenderFns } from "./ImotDetailsLink.vue?vue&type=template&id=3683c416"
import script from "./ImotDetailsLink.vue?vue&type=script&lang=js"
export * from "./ImotDetailsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports